import { useState } from 'react';

import { useLogout } from '~entities/users/hooks/use-logout';
import { useCurrentUser } from '~entities/users/model/user-store';

import { UpdatePasswordDialog } from './update-password-dialog';
import { UserMenu } from '~features/new-dashboard/ui/navbar/userMenu';

export const UserProfileMenu = () => {
  const currentUser = useCurrentUser();
  const logout = useLogout();
  const [isChangePasswordDialogOpen, setIsChangePasswordDialogOpen] = useState(false);

  // Don't show password dialog for Agency Admins - they bypass password setup
  const shouldShowPasswordDialog =
    isChangePasswordDialogOpen ||
    (currentUser?.noPassword && !currentUser?.isAgencyAdmin);

  return (
    <>
      <UserMenu
        user={{
          name: `${currentUser?.firstName} ${currentUser?.lastName}`,
          email: currentUser?.email ?? '',
        }}
        onLogout={logout}
        onChangePassword={() => {
          setIsChangePasswordDialogOpen(true);
        }}
      />
      {shouldShowPasswordDialog && (
        <UpdatePasswordDialog
          open={shouldShowPasswordDialog}
          validateCurrentPassword={!currentUser?.noPassword}
          onClose={() => {
            setIsChangePasswordDialogOpen(false);
          }}
          onOpenChange={setIsChangePasswordDialogOpen}
        />
      )}
    </>
  );
};
